import { Card } from "@f2e/ui/components/base"
import { SlackClientConfig } from "@/types"
import { SlackConnectionForm, SlackConnectionData } from "../slack"

export interface SlackConfigFieldsProps {
  config: SlackClientConfig
  isEditing: boolean
  channelId: string
  workspaceId: string
  organizationId: string
  onConfigChange?: (config: Partial<SlackClientConfig>) => void
  onSave?: (config: SlackClientConfig) => void
  isLoading?: boolean
  onDirtyChange?: (isDirty: boolean) => void
}

export const SlackConfigFields = ({
  config,
  channelId,
  workspaceId,
  organizationId,
  onConfigChange,
  onSave,
  isLoading = false,
  onDirtyChange,
}: SlackConfigFieldsProps) => {
  const handleSlackSubmit = (data: SlackConnectionData) => {
    const updatedConfig: SlackClientConfig = {
      ...config,
      botToken: data.botToken,
      signingSecret: data.signingSecret,
      teamId: data.teamId,
      teamName: data.teamName,
      botUserId: data.botUserId,
      agentId: data.agentId,
    }
    // Update local state for UI consistency
    onConfigChange?.(updatedConfig)
    // Pass the complete config directly to onSave to avoid race conditions
    onSave?.(updatedConfig)
  }

  // Slack channels always show the form - they manage their own edit/save flow
  return (
    <Card className="p-6">
      <SlackConnectionForm
        channelId={channelId}
        workspaceId={workspaceId}
        organizationId={organizationId}
        initialData={{
          botToken: config.botToken,
          signingSecret: config.signingSecret,
          teamId: config.teamId,
          teamName: config.teamName,
          botUserId: config.botUserId,
          agentId: config.agentId,
        }}
        onSubmit={handleSlackSubmit}
        isLoading={isLoading}
        onDirtyChange={onDirtyChange}
      />
    </Card>
  )
}

export default SlackConfigFields
